import { PayloadedAction } from '../../shared/types'
import { APPOINTMENT_AVAILABILITY_RESET, APPOINTMENT_DATE, APPOINTMENT_SELECTED, APPOINTMENT_SELECTED_RESET } from './appointment.actions'
import { Appointment, AppointmentAvailability, AppointmentDate, AppointmentState } from './appointment.types'

const initialAppointmentAvailability: AppointmentAvailability = { dates: [] }

export const initialState: AppointmentState = {
  appointmentAvailability: initialAppointmentAvailability,
  selectedAppointment: null
}

export function reducer(
  state: AppointmentState | undefined = initialState,
  action: PayloadedAction
): AppointmentState {
  switch (action.type) {
    case APPOINTMENT_DATE.SUCCESS: {
      const newAppointmentDate = action.payload as AppointmentDate
      const existingDates = state.appointmentAvailability.dates
      const dateExists = existingDates.some(d => d.date.getTime() === newAppointmentDate.date.getTime())
      let updatedDates: AppointmentDate[]

      if (dateExists) {
        updatedDates = existingDates.map(d => (d.date.getTime() === newAppointmentDate.date.getTime() ? newAppointmentDate : d))
      } else {
        updatedDates = [...existingDates, newAppointmentDate]
      }

      return {
        ...state,
        appointmentAvailability: {
          ...state.appointmentAvailability,
          dates: updatedDates
        }
      }
    }
    case APPOINTMENT_DATE.FAILURE: {
      return {
        ...state,
        appointmentAvailability: {
          ...state.appointmentAvailability,
          dates: [...state.appointmentAvailability.dates, { date: action.payload, slots: [], loadingInfo: { loading: false, error: true } }]
        }
      }
    }
    case APPOINTMENT_SELECTED:
      return {
        ...state,
        selectedAppointment: action.payload as Appointment
      }
    case APPOINTMENT_SELECTED_RESET:
      return {
        ...state,
        selectedAppointment: null
      }
    case APPOINTMENT_AVAILABILITY_RESET:
      return {
        ...state,
        appointmentAvailability: initialAppointmentAvailability
      }
    default:
      return state
  }
}
